import * as React from "react";
import { CountryCode } from "../../../Wrap/Constants/Enums/Domain/CountryCode";
import { CountryCodeMap } from "../../../applications/Shared/Entities/Maps/CountryCodeMap";
import { AddressDetailModel } from "../../../Wrap/Models/Models/Customer/AddressDetailModel";

export interface IAddressDisplayFieldsProps {
    address?: AddressDetailModel;
}

export class AddressDisplayFields extends React.Component<IAddressDisplayFieldsProps, any> {
    constructor(props: IAddressDisplayFieldsProps) {
        super(props);
    }

    public render(): JSX.Element {
        const currentAddress = this.props.address || ({} as AddressDetailModel);

        return (
            <>
                {currentAddress.Address && (
                    <div className="address-box">
                        <div className="house-icon" aria-hidden="true"></div>
                        <div className="address-info">
                            {currentAddress.Address?.Address1 ? <div>{currentAddress.Address?.Address1}</div> : null}
                            {currentAddress.Address?.Address2 ? <div>{currentAddress.Address?.Address2}</div> : null}
                            {currentAddress.Address?.Address3 ? <div>{currentAddress.Address?.Address3}</div> : null}
                            {/* {currentAddress.Address?.Address4 ? <div>{currentAddress.Address?.Address4}</div> : null} */}
                            {this.showCountry(currentAddress) ? (
                                <div>{CountryCodeMap.getString(currentAddress.Address?.Country)}</div>
                            ) : null}
                            {currentAddress.Address?.PostCode ? <div>{currentAddress.Address?.PostCode}</div> : null}
                        </div>
                    </div>
                )}
            </>
        );
    }

    private showCountry(address: AddressDetailModel) {
        return address.Address?.Country != null && address.Address?.Country != CountryCode.NotSpecified;
    }
}
